import o from "react";
import n from "./storyblok-component.mjs";
import { BlockTypes as m, richTextResolver as a } from "./storyblok-js.mjs";
function i(e) {
  var t, s;
  const r = (t = e == null ? void 0 : e.attrs) == null ? void 0 : t.body;
  return o.createElement(n, {
    blok: Array.isArray(r) ? r[0] : void 0,
    key: (s = e.attrs) == null ? void 0 : s.id
  });
}
function p(e) {
  const r = {
    renderFn: o.createElement,
    textFn: (t) => o.createElement(o.Fragment, {
      key: Math.random().toString(36).substring(2, 15)
    }, t),
    resolvers: {
      [m.COMPONENT]: i,
      ...e.resolvers
    },
    keyedResolvers: !0
  };
  return a(r);
}
export {
  i as componentResolver,
  p as useStoryblokRichText
};
